import type { EdiCodeDesc } from './types';

export interface DrgDisplayParts {
    code: string;
    description?: string;
    subType?: string;
}

/** Prefer top-level drgCode string, else drg.code (+ optional desc/subType). */
export function formatDrgFromFields(
    drg?: EdiCodeDesc,
    drgCode?: string,
): DrgDisplayParts | null {
    const fromString =
        typeof drgCode === 'string' && drgCode.trim() ? drgCode.trim() : '';
    const fromObj =
        drg?.code != null && String(drg.code).trim() ? String(drg.code).trim() : '';
    const code = fromString || fromObj;
    if (!code) return null;
    return {
        code,
        description: drg?.desc,
        subType: drg?.subType,
    };
}

/** Single-line label for Field components */
export function drgFieldValue(parts: DrgDisplayParts): string {
    let s = parts.code;
    if (parts.description) s += ` — ${parts.description}`;
    return s;
}
